import React,{ Component } from "react";
import { adminservice } from "../../services/admin.service";
import Loader from "../../_helpers/Loader";
import DataTable from 'react-data-table-component';
import { historypush } from "../../_helpers/utilities";

const DatatableStyle={
    table: {
        style: {
            //minHeight: '720px', // override the row height
            maxHeight: '720px',
        },
    },
}

class questionanswermeo extends Component{
    constructor(props){
        super(props);
        this.state={
            isLoading:false,
            meoQuestionList:[],
        }
    }

    componentDidMount() {
        this.setState({isLoading:true});

        this.GetQuestionBankListMEO();

        this.setState({isLoading:false});
    }

    /* <summary>
    date: 15-07-2022
    Name: VD
    description: This is used to get the list of all the Questions for the meo
    <summary>*/ 
    GetQuestionBankListMEO=async()=>{
        try{
            this.setState({
                isLoading:false,
            })
            var response = await adminservice.GetQuestionBankListMEO();
            if(response.status === 200){
                this.setState({
                    meoQuestionList:response.data,
                })
            }else if(response.status===401){
                localStorage.clear();
                historypush('/login');
            }
            this.setState({
                isLoading:false,
            })
        }catch(e){
            return "";
        }
    }

    MEOHeader = [
        {
          name: <th className="question-doc">Class</th>,
          selector: (row) =><div key={row.questionBankID}>
            {row.documentName}
            </div>,
          left: true,
          grow:3,
        },
        {
          name: <th >View</th>,
          selector: (row) =><a className="view" 
                            onClick={()=>this.openFile(row)} style={{ cursor: "pointer",paddingLeft:'13px'}}>
                                View
                            </a>,
          center: true,
        },
        // {
        //   name: <th >Delete</th>,
        //   selector: (row) =><td className="delete" onClick={()=>this.DeleteModel(row)} style={{cursor:'pointer'}}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>,
        //   center: true,
        // },
    ];

    openFile=(row)=>{
        let filePath=row.documentFilePath;
        if(filePath !== ""){
          window.open(filePath, "_blank");
        }
    }

    goBack=()=>{
        historypush('/memberportal');
    }

    render(){
        const{
            isLoading,
            meoQuestionList,
        }=this.state;
        return(
            <div className="member-body">
                {isLoading && <Loader />}
                <div className="about">
                <div className="container">
                    <h2 className="heading">Questions &amp; Answers for MEO Exams</h2>
                    <br/>
                    <div className="table-responsive">
                    {/* <table className="table question-table">
                        <thead className="quest-table-head">
                        <tr>
                            <th className="sr-no">Class</th>
                            <th className="question-doc">Subject</th>
                            <th />
                            <th />
                        </tr>
                        </thead>
                        <tbody className="quest-table-body">
                        <tr className="blue-color">
                            <td className="sr-no">Class ll</td>
                            <td>Naval architecture</td>
                            <td><a href='https://imare.in/media/11575/634544348474360000QB_EKG_ClII.pdf' rel="noreferrer" target='_blank'>View</a></td>
                            <td className="download"><i className="fa fa-download" /></td>
                        </tr>
                        </tbody>
                    </table> */}
                    <DataTable
                        columns={this.MEOHeader}
                        data={meoQuestionList}
                        noHeader={true}
                        fixedHeader={true}
                        fixedHeaderScrollHeight="450px"
                        pagination
                        customStyles={DatatableStyle}
                    />
                    </div>
                    <button type="button" onClick={()=>this.goBack()} className="question-button btn btn-white">Back</button>
                </div>
                </div>
            </div>
        )
    }
}

export default questionanswermeo;